import { useEffect, useMemo, useState } from 'react';
import useLocales from 'src/hooks/useLocales';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
// @mui
import {
  Box,
  Card,
  Table,
  Switch,
  TableBody,
  Container,
  TableContainer,
  TablePagination,
  FormControlLabel,
  Divider,
} from '@mui/material';

import { useSnackbar } from 'notistack';
import { observer } from 'mobx-react-lite';
import MyDialog from 'src/components/MyDialog';

import ContractInfoTableToolbar from '../ContractInfoTableToolbar';
import PermissionBasedGuard from 'src/guards/PermissionBasedGuard';
import HeaderBreadcrumbs from 'src/components/HeaderBreadcrumbs';
import Iconify from 'src/components/Iconify';
import Scrollbar from 'src/components/Scrollbar';
import { TableHeadCustom, TableEmptyRows, TableNoData } from 'src/components/table';
import useSettings from 'src/hooks/useSettings';
import useTable, { getComparator, emptyRows } from 'src/hooks/useTable';
import { PATH_DASHBOARD } from 'src/routes/paths';
import Page from 'src/components/Page';
import { useStore } from 'src/stores/store';
import { IContractInfo } from 'src/@types/Choqorak/MainTables/Contract/ContractInfo';

import useTabs from 'src/hooks/useTabs';
import ContractInfoDiscount from '../ContractInfoDiscount';
import ContractInfoDelete from '../ContractInfoDelete';
import ContractInfoRecievedAdvance from '../ContractInfoRecievedAdvance';
import ContractInfoLock from '../ContractInfoLock';
import { storeIdToLocalStorage } from 'src/Common/storeIdToLocalStorage';
import Label from 'src/components/Label';
import ContractInfoAttachment from '../ContractInfoAttachment';
import ContractInfoExtend from '../ContractInfoExtend';
import RentAdvancePayment from '../RentAdvancePayment';
import ContractInfoTableRow from './ContractInfoTableRow';

// ----------------------------------------------------------------------

export default observer(function ContractInfoActiveContractList() {
  const { ContractInfoStore } = useStore();
  const { translate } = useLocales();
  const {
    loadActiveContractList,
    ContractInfoList,
    ContractInfoRegistry,
    totalRecord,
    ContractInfoActiveSearch,
    deleteContractInfo,
    getContractInfoFromRegistry,
    setOpenCloseDialog,
    openDialog,
    loadContractInfoDetail,
    ApproveDiscountDialog,
    AdvancePayDialog,
    ApprovedAndLock,
    AttanchmentDialog,
    ContractExtentDialog,
    setOpenCloseApproveDiscountDialog,
    setOpenCloseAdvancePayDialogDialog,
    setOpenCloseApprovedAndLockDialog,
    setOpenCloseAttachmentDialog,
    setOpenCloseExtendDialog,
    setOpenCloseRentAdvancePaymentDialog,
    RentAdvancePaymentDialog,
  } = ContractInfoStore;
  const {
    dense,
    page,
    order,
    orderBy,
    rowsPerPage,
    setPage,
    onSort,
    onChangeDense,
    onChangeRowsPerPage,
  } = useTable();
  const { themeStretch, tablePagination, onChangePagination } = useSettings();

  const [searchBy, setsearchBy] = useState('');

  const navigate = useNavigate();

  const { enqueueSnackbar } = useSnackbar();

  const [ContractInfoId, setContractInfoId] = useState<number>(0);
  const TABLE_HEAD = [
    { id: 'ID', label: `${translate('contractsInfo.No')}`, align: 'left' },
    { id: 'contractNumber', label: `${translate('contractsInfo.ContractNumber')}`, align: 'left' },
    { id: 'customerName', label: `${translate('contractsInfo.CustomerName')}`, align: 'left' },
    { id: 'shopCode', label: `${translate('contractsInfo.ShopCode')}`, align: 'left' },
    {
      id: 'contractStartDate',
      label: `${translate('contractsInfo.StartDate')}`,
      align: 'left',
    },
    {
      id: 'contractEndDate',
      label: `${translate('contractsInfo.EndDate')}`,
      align: 'left',
    },
    {
      id: 'ContractDuration',
      label: `${translate('contractsInfo.ContractDuration')}`,
      align: 'left',
    },
    {
      id: 'advancepayment',
      label: `${translate('contractsInfo.AdvancePayment')}`,
      align: 'left',
    },
    {
      id: 'FinalRentPerMonth',
      label: `${translate('contractsInfo.FinalRentPerMonth')}`,
      align: 'left',
    },
    { id: 'contractStatus', label: `${translate('contractsInfo.Status')}`, align: 'left' },
    { id: '', label: `${translate('GeneralFields.Action')}` },
  ];
  const handlesearchBy = (searchBy: string) => {
    setsearchBy(searchBy);
    setPage(0);
    if (searchBy.length > 1) {
      ContractInfoActiveSearch({
        pageIndex: 0,
        pageSize: tablePagination,
        searchBy: searchBy,
      });
    } else if (searchBy === '') {
      ContractInfoActiveSearch({ pageIndex: 0, pageSize: tablePagination });
    }
  };

  const handleOpenConfirm = (id: number) => {
    setOpenCloseDialog();
    setContractInfoId(id);
  };

  const handleCloseConfirm = () => {
    setOpenCloseDialog();
  };
  const handleEditRow = (id: number) => {
    getContractInfoFromRegistry(id);
    navigate(PATH_DASHBOARD.ContractInfo.edit);
  };

  //#region Details
  const handleDetail = (id: number) => {
    storeIdToLocalStorage(id, ContractInfoStore);

    loadContractInfoDetail(id).then(() => {
      navigate(PATH_DASHBOARD.ContractInfo.detail);
    });
  };
  //#endregion

  //#region ApproveDiscount
  const handleApproveDiscount = (id: number) => {
    loadContractInfoDetail(id).then(() => {
      setOpenCloseApproveDiscountDialog();
    });
  };

  const handleCloseApproveDiscount = () => {
    setOpenCloseApproveDiscountDialog();
  };
  //#endregion

  //#region contract Extend
  const handleExtend = (id: number) => {
    loadContractInfoDetail(id).then(() => {
      setOpenCloseExtendDialog();
    });
  };

  const handleCloseExtend = () => {
    setOpenCloseExtendDialog();
  };
  //#endregion

  //#region Attachment
  const handleAttachment = (id: number) => {
    loadContractInfoDetail(id).then(() => {
      setOpenCloseAttachmentDialog();
    });
  };

  const handleCloseAttachment = () => {
    setOpenCloseAttachmentDialog();
  };
  //#endregion

  //#region RecievedAdvanceApproval
  const handleRecievedAdvanceApproval = (id: number) => {
    loadContractInfoDetail(id).then(() => {
      setOpenCloseAdvancePayDialogDialog();
    });
  };

  const handleCloseRecievedAdvanceApproval = () => {
    setOpenCloseAdvancePayDialogDialog();
  };
  //#endregion

  //#region ApprovedAndLockContract
  const handleApprovedAndLockContract = (id: number) => {
    loadContractInfoDetail(id).then(() => {
      setOpenCloseApprovedAndLockDialog();
    });
  };

  const handleCloseApprovedAndLockContract = () => {
    setOpenCloseApprovedAndLockDialog();
  };
  //#endregion

  //#region handleRentAdvancPaymentContract
  const handleRentAdvancPayment = (id: number) => {
    loadContractInfoDetail(id).then(() => {
      setOpenCloseRentAdvancePaymentDialog();
    });
  };


  const handleDiscountDocumentView = (id: number) => {
    loadContractInfoDetail(id).then(() => {
      navigate(PATH_DASHBOARD.ContractInfo.pdfdiscountviewer);
    });
  };

  const handleCloseRentAdvancePayment = () => {
    setOpenCloseRentAdvancePaymentDialog();
  };
  //#endregion

  //#region ContractTerminate
  const handleContractTerminate = (id: number) => {
    loadContractInfoDetail(id).then(() => {
      navigate(PATH_DASHBOARD.ContractInfo.terminate);
    });
  };
  //#endregion

  //#region ContractTerminate
  const handleDocumentView = (id: number) => {
    loadContractInfoDetail(id).then(() => {
      navigate(PATH_DASHBOARD.ContractInfo.pdfviewer);
    });
  };
  //#endregion

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
    loadActiveContractList({ pageIndex: newPage, pageSize: tablePagination }, true);
  };
  const handlePageSizeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChangePagination(event.target.value);

    onChangeRowsPerPage(event);
    let pageZize = parseInt(event.target.value);
    loadActiveContractList({ pageIndex: 0, pageSize: pageZize });
  };

  useEffect(() => {
    onChangeRowsPerPage(tablePagination);
    loadActiveContractList({ pageIndex: 0, pageSize: tablePagination });
  }, [loadActiveContractList, tablePagination]);

  useEffect(() => {
    if (ContractInfoRegistry.size <= 1) {
      loadActiveContractList({ pageIndex: 0, pageSize: rowsPerPage });
    }
  }, []);

  //#region for filtering tabs

  const getLengthByStatus = (status: string) => {
    // ContractInfoList.filter((item) => item.processStatusId?.toString() === status).length;
  };

  //#endregion

  const dataFiltered = applySortFilter({
    tableData: ContractInfoList,
    comparator: getComparator(order, orderBy),
    searchBy: '',
  });

  const denseHeight = dense ? 52 : 72;

  const isNotFound = !dataFiltered.length && !!searchBy;

  return (
    <Page title={translate('contractsInfo.ActiveContractList')}>
      <Container maxWidth={themeStretch ? false : 'lg'}>
        <HeaderBreadcrumbs
          heading={translate('contractsInfo.ActiveContractList')}
          links={[
            { name: `${translate('Department.Dashboard')}`, href: PATH_DASHBOARD.root },

            { name: `${translate('contractsInfo.ActiveContractList')}` },
          ]}
        // action={
        //   <>
        //     <PermissionBasedGuard permissions={['Contract-Create']}>
        //       <Button
        //         variant="contained"
        //         startIcon={<Iconify icon="eva:plus-fill" />}
        //         component={RouterLink}
        //         to={PATH_DASHBOARD.ContractInfo.new}
        //       >
        //         {translate('CRUD.Create')}
        //       </Button>
        //     </PermissionBasedGuard>
        //   </>
        // }
        />

        <Card>
          <Divider />
          <ContractInfoTableToolbar searchBy={searchBy} onsearchBy={handlesearchBy} />

          <Scrollbar>
            <TableContainer sx={{ maxHeight: 600, minWidth: 960, position: 'relative' }}>
              <Table stickyHeader size={dense ? 'small' : 'medium'}>
                <TableHeadCustom
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={totalRecord}
                  onSort={onSort}
                />

                <TableBody>
                  {dataFiltered
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => (
                      <ContractInfoTableRow
                        key={row.contractId}
                        row={row}
                        index={index}
                        handleAttachment={() => handleAttachment(row.contractId!)}
                        handleApproveDiscount={() => handleApproveDiscount(row.contractId!)}
                        handleExtend={() => handleExtend(row.contractId!)}
                        handleRecievedAdvanceApproval={() =>
                          handleRecievedAdvanceApproval(row.contractId!)
                        }
                        handleApprovedAndLockContract={() =>
                          handleApprovedAndLockContract(row.contractId!)
                        }
                        handleRentAdvancPayment={() => handleRentAdvancPayment(row.contractId!)}
                        handleContractTerminate={() => handleContractTerminate(row.contractId!)}
                        handleDiscountDocumentView={() => handleDiscountDocumentView(row.contractId!)}
                        handleDocumentView={() => handleDocumentView(row.contractId!)}
                        handleDetail={() => handleDetail(row.contractId!)}
                        onDeleteRow={() => handleOpenConfirm(row.contractId!)}
                        onEditRow={() => handleEditRow(row.contractId!)}
                      />
                    ))}

                  <TableEmptyRows
                    height={denseHeight}
                    emptyRows={emptyRows(page, rowsPerPage, totalRecord)}
                  />

                  <TableNoData isNotFound={isNotFound} />
                </TableBody>
              </Table>
            </TableContainer>
          </Scrollbar>

          <Box sx={{ position: 'relative' }}>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, 50, 100, 150, 200]}
              component="div"
              labelRowsPerPage={translate('Pagination.RowsPerPage')}
              count={totalRecord}
              labelDisplayedRows={({ from, to, count }) =>
                `${from}-${to} ${translate('Pagination.Of')} ${count}`
              }
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handlePageSizeChange}
            />
            <MyDialog
              open={openDialog}
              onClose={handleCloseConfirm}
              title={translate('CRUD.DeleteTitle')}
              size="md"
            >
              <ContractInfoDelete id={ContractInfoId} />
            </MyDialog>

            <MyDialog
              open={ApproveDiscountDialog}
              onClose={handleCloseApproveDiscount}
              title={translate('CRUD.ApproveDiscount')}
              size="md"
            >
              <ContractInfoDiscount id={ContractInfoId} />
            </MyDialog>

            <MyDialog
              open={AdvancePayDialog}
              onClose={handleCloseRecievedAdvanceApproval}
              title={translate('contractsInfo.RecievedAdvanceApproval')}
              size="md"
            >
              <ContractInfoRecievedAdvance id={ContractInfoId} />
            </MyDialog>

            <MyDialog
              open={ApprovedAndLock}
              onClose={handleCloseApprovedAndLockContract}
              title={translate('contractsInfo.MarkContractasComplete')}
              size="md"
            >
              <ContractInfoLock id={ContractInfoId} />
            </MyDialog>

            <MyDialog
              open={AttanchmentDialog}
              onClose={handleCloseAttachment}
              title={translate('CRUD.Contract Attachment')}
              size="xs"
            >
              <ContractInfoAttachment id={ContractInfoId} />
            </MyDialog>

            <MyDialog
              open={ContractExtentDialog}
              onClose={handleCloseExtend}
              title={translate('CRUD.ContractExtend')}
              size="md"
            >
              <ContractInfoExtend id={ContractInfoId} />
            </MyDialog>

            <MyDialog
              open={RentAdvancePaymentDialog}
              onClose={handleCloseRentAdvancePayment}
              title={translate('CRUD.Rent Advance Payment')}
              size="md"
            >
              <RentAdvancePayment id={ContractInfoId} />
            </MyDialog>

            <FormControlLabel
              control={<Switch checked={dense} onChange={onChangeDense} />}
              label={translate('Pagination.Dense')}
              sx={{ px: 3, py: 1.5, top: 0, position: { md: 'absolute' } }}
            />
          </Box>
        </Card>
      </Container>
    </Page>
  );
});

// ----------------------------------------------------------------------

function applySortFilter({
  tableData,
  comparator,
  searchBy,
}: {
  tableData: IContractInfo[];
  comparator: (a: any, b: any) => number;
  searchBy: string;
}) {
  const stabilizedThis = tableData.map((el, index) => [el, index] as const);

  // stabilizedThis.sort((a, b) => {
  //   const order = comparator(a[0], b[0]);
  //   if (order !== 0) return order;
  //   return a[1] - b[1];
  // });

  tableData = stabilizedThis.map((el) => el[0]);

  if (searchBy) {
    tableData = tableData.filter(
      (item: Record<string, any>) =>
        item.searchBy.toLowerCase().indexOf(searchBy.toLowerCase()) !== -1
    );
  }

  return tableData;
}
